// extracted by mini-css-extract-plugin
export default {"container":"PM-z","topReviewHeading":"QM-z","criticalReview":"RM-z","favorableReview":"SM-z","vsSeparator":"TM-z"};